<template>
	<transition name="ui--content">
		<div
			v-if="isOpen"
			class="ui ui--content"
			:mode="mode"
			:loading="contentModalIsLoading"
			:loaded="!contentModalIsLoading"
			:article-id="toggleArticleViews ? firstParameters.articleID : secondParameters.articleID"
			:exhibition-id="toggleArticleViews ? firstParameters.exhibitionID : secondParameters.exhibitionID"
		>
			<transition name="modal-article-content">
				<article-view
					v-if="toggleArticleViews"
					v-bind="firstParameters"
					:style="noContentInteraction ? 'pointer-events: none;' : null"
				></article-view>
				<article-view
					v-else
					v-bind="secondParameters"
					:style="noContentInteraction ? 'pointer-events: none;' : null"
				></article-view>
			</transition>
			<ElementButton name="close" @click="close" />
			<UiNavigation position="modal" :hideOnScroll="false" isSubComponent />
		</div>
	</transition>
</template>

<script>
import { mapState } from 'vuex';
import UiBase from './base.vue';
import { uiComponents } from '@/tools/viewState';
import { mapStateNested } from '@/tools/helpers';
import ArticleView from '../ArticleView.vue';
import UiNavigation from '../ui/navigation.vue';

export default {
	extends: UiBase,
	data() {
		return {
			toggleArticleViews: false,
			name: uiComponents.uiContent,
			firstParameters: {},
			secondParameters: {},
		};
	},
	components: {
		UiNavigation,
		ArticleView,
	},
	methods: {
		setArticleWrappers() {
			this.toggleArticleViews = !this.toggleArticleViews;
			if (this.toggleArticleViews) {
				this.firstParameters = {
					articleID: this.articleID,
					tourID: this.tourID,
					exhibitionID: this.exhibitionID,
					isInModal: true,
				};
				this.firstExhibitionID = this.exhibitionID;
			} else {
				this.secondParameters = {
					articleID: this.articleID,
					tourID: this.tourID,
					exhibitionID: this.exhibitionID,
					isInModal: true,
				};
			}
		},
	},
	computed: {
		...mapState(['contentModalIsLoading']),
		...mapStateNested('contentModal', [
			'articleID',
			'exhibitionID',
			'tourID',
			'mode',
			'noContentInteraction',
		]),
	},
	watch: {
		articleID() {
			this.setArticleWrappers();
		},
	},
	mounted() {
		this.setArticleWrappers();
	},
};
</script>
